const LoginSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">🔐 Đăng Nhập và Bắt Đầu</h2>

            <div className="bg-white p-6 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Cách đăng nhập:</h3>
                <ol className="list-decimal list-inside space-y-2 text-slate-700">
                    <li>Truy cập trang web hệ thống LMS</li>
                    <li>Nhập <strong>email</strong> và <strong>mật khẩu</strong> do giáo viên cung cấp</li>
                    <li>Nhấn nút <strong>"Đăng nhập"</strong></li>
                </ol>
            </div>

            <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200">
                <h3 className="text-lg font-semibold text-yellow-900 mb-2">⚠️ Lần đầu đăng nhập</h3>
                <ul className="text-slate-700 space-y-2">
                    <li>• Bạn sẽ được chuyển đến trang Dashboard (trang chủ)</li>
                    <li>• Nên đổi mật khẩu mặc định ngay lập tức trong phần Thông tin cá nhân</li>
                    <li>• Khám phá các menu và tính năng có sẵn</li>
                </ul>
            </div>

            <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
                <h3 className="text-lg font-semibold text-blue-900 mb-2">📱 Truy cập trên Di động</h3>
                <p className="text-slate-700">
                    Hệ thống hỗ trợ đầy đủ trên điện thoại và máy tính bảng. Giao diện tự động điều chỉnh
                    cho màn hình nhỏ và tất cả tính năng đều hoạt động trên mobile.
                </p>
            </div>
        </div>
    );
};

export default LoginSection;
